import React, { Component } from "react";
import { ROUTES } from "const";
import { withRouter, NavLink } from "react-router-dom";
import { Icon } from "design-react-kit";
import { BoxDanger, MnemoLoading, MSection, SupportoTecnico, Title } from "components/misc";
import { courseService,  networkErrorHelper } from "libs";
import { MTable } from "components/table";

class CourseModulesTFAClassico extends Component {
  state = {
    loading: true,
    loadingError: false,
    rCode: "",
    insegnamenti: [],
    laboratori: [],
    course: [],
    courseYear: parseInt(process.env.REACT_APP_AA_YEAR),
  };

  tableConfigInsegnamenti = {
    columns: [
      {
        id: "title",
        Header: "Insegnamento",
        accessor: "title",
      },
      {
        id: "ssd",
        Header: "SSD",
        accessor: "ssd",
      },
      {
        id: "cfu",
        Header: "CFU",
        accessor: "cfu",
      },
      {
        id: "vote",
        Header: "Voto",
        accessor: "vote",
      },
      {
        id: "date",
        Header: "Data conseguimento",
        accessor: "date"
      },
    ],
  };

  tableConfigLaboratori = {
    columns: [
      {
        id: "title",
        Header: "Laboratorio",
        accessor: "title",
      },
      {
        id: "ssd",
        Header: "SSD",
        accessor: "ssd",
      },
      {
        id: "cfu",
        Header: "CFU",
        accessor: "cfu",
      },
      {
        id: "vote",
        Header: "Voto",
        accessor: "vote",
      },
      {
        id: "date",
        Header: "Data conseguimento",
        accessor: "date"
      }
    ],
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.setState({ rCode });
    this.loadRemote(rCode);
  } 

  loadRemote(rCode) {
 
    courseService.myCourseModulesTFAClassico(rCode, "tfaclassico_insegnamenti")    
    
      .then(({data}) => {

        console.log(data);
        const insegnamenti = data.payload || [];        

        this.setState({insegnamenti});

        this.loadLaboratori(rCode);
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
          this.setState({ loadingError: true });
        }

        this.setState({ loading: false });
      });
  }

  loadLaboratori(rCode) {
 
    courseService.myCourseModulesTFAClassico(rCode, "tfaclassico_laboratori")    
    
      .then(({data}) => {
        
        const { laboratori} = data.payload || [];                        
        console.log(laboratori);

        this.setState({
          laboratori,               
        });       
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
          this.setState({ loadingError: true });
        }

        this.setState({ loading: false });
      });
  }

  render() {
    const { loading, loadingError, rCode, insegnamenti, laboratori } = this.state;

    if (loadingError)
      return (
        <BoxDanger className="m-5">
          Si è verificato un errore durante l'elaborazione della richiesta, se il problema persiste puoi <SupportoTecnico />
        </BoxDanger>
      );

    return (
      <>
        {loading && <MnemoLoading />}
        <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right">
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Consultazione esiti</Title>
        <MSection className="m-3">
          {insegnamenti.length > 0 && (
            <div className="mb-5">
              <h5 className="mb-1 font-weight-bold">Insegnamenti</h5>
              <hr />
              <MTable tableData={insegnamenti} tableConfig={this.tableConfigInsegnamenti} />
            </div>
          )}
     

        {laboratori.length > 0 && (
          <div>
            <h5 className="mb-3 font-weight-bold">Laboratori</h5>
            <hr />
            <MTable tableData={laboratori} tableConfig={this.tableConfigLaboratori} />
          </div>
        )}
   </MSection>

      </>
    );
  }
}

export default withRouter(CourseModulesTFAClassico);
